<div class="sidebar-item">
  <a [href]="route || '#'" (click)="onClick($event)" class="sidebar-item__link">
    <div
      class="sidebar-item__btn"
      [class.sidebar-item__btn--active]="isSelfSelected() || isAnyChildSelected()"
      [class.sidebar-item__btn--collapsed]="!isSidebarOpen"
    >
      @if (icon) {
        <span class="material-symbols-outlined sidebar-item__icon">{{ icon }}</span>
      } @else if (iconUrl) {
        <img [src]="iconUrl" alt="" />
      } @else if (iconClass) {
        <i [class]="iconClass + ' sidebar-item__pi-icon'"></i>
      }

      {{ title }}

      <span
        class="sidebar-item__right-icon"
        [class.rotated]="isExpanded"
        [class.sidebar-item__right-icon--collapsed]="!isSidebarOpen"
      >
        @if (isCollapsable) {
          <span class="material-symbols-outlined">keyboard_arrow_down</span>
        }
      </span>

      @if (!isCollapsable && newBtn) {
        <span class="sidebar-item__options-icon" (click)="goToCreate($event)">
          <span class="material-symbols-outlined">add</span>
        </span>
      }
    </div>

    @if (isExpanded && isSidebarOpen) {
      <ul class="sidebar-item__list">
        <div
          class="sidebar-item__list-container"
          [class.sidebar-item__list-container--collapsed]="!isSidebarOpen"
        >
          <ng-content></ng-content>
        </div>
      </ul>
    }
  </a>
</div>
